import Passenger from '@/components/Passenger/models/Passenger';
import { IEntityMapping, IPropertyMapping } from '@/typings/import';

export default class PassengerSearchMapping implements IEntityMapping<Passenger> {

  name: IPropertyMapping = {
    propertyName: 'name',
    propertyType: 'string',
    required: false,
    static: null,
    cell: null,
    allowStatic: false,
    useStatic: false
  };
  externalId: IPropertyMapping = {
    propertyName: 'externalId',
    propertyType: 'string',
    required: false,
    allowStatic: false,
    useStatic: false
  };
  ssn: IPropertyMapping = {
    propertyName: 'ssn',
    propertyType: 'string',
    required: false,
    allowStatic: false,
    useStatic: false
  };
  
  constructor(mapping?: IEntityMapping<Passenger>) {
    if (mapping) {
      Object.keys(mapping).forEach(k => this[k] = mapping[k]);
    }
  }

  get props(): IPropertyMapping[] {
    return Object.keys(this).map(k => this[k]);
  }

  isValid(): boolean {
    return true;
  }

  updateSearchProperty(searchProperty: IPropertyMapping) {
    let updatedProperty: IPropertyMapping | null = null;
    switch (searchProperty.propertyName) {
      case 'name':
        updatedProperty = this.name;
        break;
      case 'externalId':
        updatedProperty = this.externalId;
        break;
      case 'ssn':
        updatedProperty = this.ssn;
        break;
    }
    if (!updatedProperty) {
      return;
    }

    updatedProperty.cell = searchProperty.cell;
    updatedProperty.static = searchProperty.static;
    updatedProperty.useStatic = searchProperty.useStatic;
  }
}
